import React from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction, setUIBackwardsAction, updateReservationAndGoHomeAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import './dangerousGoods.less'
import { USERNOTE_I_HAVE_DANGEROUS_GOODS } from '../../../constants/userNote'
import DangerousGoodsImg from '../../../assets/dangerous-goods.png'
import FooterMobile from '../../FooterMobile'
import { getMode } from '../../../hooks/mode'
import { MODE } from '../../../constants/mode'

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
  updateReservationAndGoHome: updateReservationAndGoHomeAction,
}
type DispatchProps = typeof mapDispatchToProps

const DangerousGoodsMobile: React.FC<DispatchProps> = ({
  setUIForward,
  setUIBackwards,
  updateReservationAndGoHome,
}: DispatchProps) => {
  const { t } = useTranslation()
  return (
    <div className="dangerous-goods-mobile">
      <div className="dangerous-goods-mobile-wrapper">
        <div className="dangerous-goods-title" dangerouslySetInnerHTML={{ __html: t('dangerousGoods') }}></div>
        <div className="img-container">
          <img className="dangerous-goods-img" src={DangerousGoodsImg} alt="dangerous goods" />
        </div>
        <div className="dangerous-goods-button">
          <button
            className="main-button-mobile next"
            onClick={() => setUIForward(UI.CONFIRM_CONNECTION)}
            dangerouslySetInnerHTML={{ __html: t('dangerousGoodsNo') }}
          ></button>
        </div>
        <div className="dangerous-goods-button">
          <button
            className="main-button-mobile next"
            onClick={() => updateReservationAndGoHome(USERNOTE_I_HAVE_DANGEROUS_GOODS)}
            dangerouslySetInnerHTML={{ __html: t('dangerousGoodsYes') }}
          ></button>
        </div>
      </div>
      <div className="footer-mobile-container">
        <FooterMobile showPageCount back={() => setUIBackwards(UI.CONFIRM_RESERVATION)} />
      </div>
    </div>
  )
}

const DangerousGoodsDesktop: React.FC<DispatchProps> = ({
  setUIForward,
  setUIBackwards,
  updateReservationAndGoHome,
}: DispatchProps) => {
  const { t } = useTranslation()
  return (
    <>
      <Header showPageCount back={() => setUIBackwards(UI.CONFIRM_RESERVATION)} />
      <div className="dangerous-goods">
        <div className="dangerous-goods-title" dangerouslySetInnerHTML={{ __html: t('dangerousGoods') }}></div>
        <div className="img-container">
          <img className="dangerous-goods-img" src={DangerousGoodsImg} alt="dangerous goods" />
        </div>
        <div className="dangerous-goods-button">
          <button
            className="main-button next"
            onClick={() => setUIForward(UI.CONFIRM_CONNECTION)}
            dangerouslySetInnerHTML={{ __html: t('dangerousGoodsNo') }}
          ></button>
        </div>
        <div className="dangerous-goods-button">
          <button
            className="main-button next"
            onClick={() => updateReservationAndGoHome(USERNOTE_I_HAVE_DANGEROUS_GOODS)}
            dangerouslySetInnerHTML={{ __html: t('dangerousGoodsYes') }}
          ></button>
        </div>
      </div>
      <Footer />
    </>
  )
}

const DangerousGoods: React.FC<DispatchProps> = (props: DispatchProps) => {
  const mode = getMode()

  if (mode === MODE.MOBILE) {
    return <DangerousGoodsMobile {...props} />
  } else {
    return <DangerousGoodsDesktop {...props} />
  }
}

export default connect(null, mapDispatchToProps)(DangerousGoods)
